import { TrendingUp, TrendingDown } from 'lucide-react'

interface ScoreHeroProps {
  score: number
  previousScore?: number
  label?: string
}

function getScoreColor(score: number): string {
  if (score >= 90) return '#10B981'
  if (score >= 50) return '#FBBF24'
  return '#EF4444'
}

export function ScoreHero({ score, previousScore, label }: ScoreHeroProps) {
  const color = getScoreColor(score)

  const delta =
    previousScore !== undefined
      ? ((score - previousScore) / Math.max(previousScore, 1)) * 100
      : null

  const improved = delta !== null && delta >= 0

  return (
    <div className="flex flex-col items-center gap-1">
      <div className="flex items-end gap-2">
        <span
          className="text-[48px] font-bold leading-none"
          style={{ color }}
        >
          {score}
        </span>

        {delta !== null && (
          <div
            className="flex items-center gap-0.5 mb-2 text-sm font-medium"
            style={{ color: improved ? '#10B981' : '#EF4444' }}
          >
            {improved ? (
              <TrendingUp size={16} />
            ) : (
              <TrendingDown size={16} />
            )}
            <span>
              {improved ? '+' : ''}
              {delta.toFixed(1)}%
            </span>
          </div>
        )}
      </div>

      {label && (
        <span className="text-sm text-[#8B8FA7]">{label}</span>
      )}
    </div>
  )
}
